/* OREN — Quick search: Cmd/Ctrl+K overlay, live results via /search/suggest.json */
(function(){
  var root = document.querySelector('[data-qs]');
  if(!root) return;
  var input = root.querySelector('[data-qs-input]');
  var results = root.querySelector('[data-qs-results]');
  var hintHtml = '<div class="qs-hint">Type to search the archive. Esc closes.</div>';
  var open = false, timer = null, seq = 0;

  function show(){
    root.classList.add('open');
    root.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    open = true;
    setTimeout(function(){ input.focus(); }, 60);
  }
  function hide(){
    root.classList.remove('open');
    root.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    open = false;
  }

  document.querySelectorAll('[data-qs-open]').forEach(function(el){
    el.addEventListener('click', function(e){ e.preventDefault(); show(); });
  });
  document.addEventListener('keydown', function(e){
    if((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')){
      e.preventDefault();
      if(open) hide(); else show();
    } else if(e.key === 'Escape' && open){
      hide();
    }
  });
  root.addEventListener('click', function(e){
    if(e.target.closest('[data-qs-close]') || e.target.classList.contains('qs-overlay')) hide();
  });

  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
  function fmtPrice(p){
    if(!p) return '';
    var n = parseFloat(p);
    if(isNaN(n)) return esc(p);
    return (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2).replace('.', ',')) + ' \u20ac';
  }

  function render(d, q){
    var res = (d && d.resources && d.resources.results) || {};
    var prods = res.products || [];
    var arts = res.articles || [];
    if(!prods.length && !arts.length){
      results.innerHTML = '<div class="qs-hint">Nothing by that name. The archive is quiet.</div>';
      return;
    }
    var h = '';
    if(prods.length){
      h += '<div class="qs-group">// Fragments</div>' + prods.map(function(p){
        var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="qs-noimg"></span>';
        return '<a class="qs-item" href="' + p.url + '">' + img
          + '<span class="qs-name">' + esc(p.title) + '</span>'
          + '<span class="qs-meta">' + fmtPrice(p.price) + '</span></a>';
      }).join('');
    }
    if(arts.length){
      h += '<div class="qs-group">// Journal</div>' + arts.map(function(a){
        return '<a class="qs-item" href="' + a.url + '">'
          + '<span class="qs-noimg qs-dot"></span>'
          + '<span class="qs-name">' + esc(a.title) + '</span>'
          + '<span class="qs-meta">Journal</span></a>';
      }).join('');
    }
    h += '<a class="qs-all" href="/search?q=' + encodeURIComponent(q) + '">All results \u2192</a>';
    results.innerHTML = h;
  }

  input.addEventListener('input', function(){
    var q = input.value.trim();
    clearTimeout(timer);
    if(q.length < 2){ results.innerHTML = hintHtml; return; }
    timer = setTimeout(function(){
      var my = ++seq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,article&resources[limit]=6')
        .then(function(r){ return r.json(); })
        .then(function(d){ if(my === seq) render(d, q); })
        .catch(function(){});
    }, 180);
  });
})();
